const inject = (id) => {
  const isNotLoaded = typeof window.KAMPYLE_ONSITE_SDK === "undefined";
  if (isNotLoaded) {
    const src = `https://resources.digital-cloud.medallia.eu/wdceu/${id}/onsite/embed.js`;
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }
};
const virtualPageView = () => {
  if (window.KAMPYLE_ONSITE_SDK && typeof window.KAMPYLE_ONSITE_SDK.updatePageView === "function") {
    window.KAMPYLE_ONSITE_SDK.updatePageView();
  }
};
const medalliaClient = () => {
  return window.KAMPYLE_ONSITE_SDK;
};

export { inject, medalliaClient, virtualPageView };
//# sourceMappingURL=b2x-medallia.esm.js.map
